__turbopack_context__.v({
  "container": "MfLOna_container",
  "emptyPlaceholder": "MfLOna_emptyPlaceholder",
  "header": "MfLOna_header",
  "midDot": "MfLOna_midDot",
  "orderList": "MfLOna_orderList",
});
